module.exports = __webpack_public_path__ + "img/mahindra_thumbnail.fabc532a.png";